import React from 'react';
import { Box, Typography, List, ListItem, ListItemText } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MLIcon from '../../../MLIcon/MLIcon';
import IndividualStudentGradebookChat from '../../IndividualStudentGradebookChat/IndividualStudentGradebook';
import {
  MultiChartDashboard,
  MultiChartCompletionDashboard,
  MultiChartSectionAveragesDashboard,
  MultiChartAssignmentAveragesDashboard,
} from '../Charts';
import {
  RootBox,
  SectionBox,
  ToolItemDiv,
  StudentHeaderPaper,
  StudentNameTypography,
  StudentInfoTypography,
  GbLink,
  CloseButton,
  closeIconStyles,
} from './styles';

const StudentWithGrades = ({ toolData }) => {
  if (!toolData.student || !toolData.section) return null;
  const isgUrl = `/courses/${toolData.section.shortId}/performance?studentId=${toolData.student.userId}`;
  return (
    <Box>
      <StudentHeaderPaper elevation={2}>
        <StudentNameTypography variant="h6">
          {toolData.student.name || 'Student'}
        </StudentNameTypography>
        <StudentInfoTypography variant="body2">
          Section: {toolData.section.name || toolData.section.shortName}
        </StudentInfoTypography>
        {toolData.student.email && (
          <Typography variant="body2">
            Email: {toolData.student.email}
          </Typography>
        )}
        <GbLink href={isgUrl} target="_blank" color="inherit" variant="body1">
          Go to Gradebook
        </GbLink>
      </StudentHeaderPaper>

      <IndividualStudentGradebookChat
        studentGradebook={toolData}
        isChat
        hasStudents
        settings={{}}
        user={{ thirdPartyUserId: '' }}
        userId={toolData.student.userId}
        roster={[]}
        courseId={toolData.section.id}
        getLaunchUrl={() => {}}
        handleLocalLaunch={() => {}}
        getStudentReportLink={() => {}}
        hasStudentReport={false}
      />
    </Box>
  );
};

const ToolComponents = {
  findStudentWithGrades: ({ toolData }) => (
    <StudentWithGrades toolData={toolData} />
  ),
  studentAverageResults: ({ toolData }) => (
    <MultiChartDashboard data={toolData} />
  ),
  sectionCompletionPercentages: ({ toolData }) => (
    <MultiChartCompletionDashboard data={toolData} />
  ),
  sectionAverages: ({ toolData }) => (
    <MultiChartSectionAveragesDashboard data={toolData} />
  ),
  sectionAssignmentAverages: ({ toolData }) => (
    <MultiChartAssignmentAveragesDashboard data={toolData} />
  ),
};

const ToolRenderer = ({ toolName, toolData }) => {
  const Component = ToolComponents[toolName];

  return Component ? (
    <Component toolData={toolData} />
  ) : (
    <>
      <ListItem>
        <ToolItemDiv>
          <ListItemText
            primary={toolName}
            secondary={<pre>{JSON.stringify(toolData, null, 2)}</pre>}
          />
        </ToolItemDiv>
      </ListItem>
    </>
  );
};

const DataColumn = React.memo(function DataColumn({
  toolData,
  toolName,
  onClose,
}) {
  const theme = useTheme();

  return (
    <RootBox>
      {onClose && (
        <CloseButton
          size="small"
          aria-label="Close panel"
          onClick={onClose}
          data-test-id="data_panel_close"
        >
          <MLIcon type="x" title="Close" sx={closeIconStyles(theme)} />
        </CloseButton>
      )}
      {toolName && (
        <SectionBox>
          <List>
            <ToolRenderer toolName={toolName} toolData={toolData} />
          </List>
        </SectionBox>
      )}
    </RootBox>
  );
});

export default DataColumn;
